import api from './axiosClient'
import { GetCalendarEventsResponse } from '../../proto/generated/calendar-event'

export type CalendarEventsQueryParams = {
    from_date?: string
    to_date?: string
    code?: string
}

export const getCalendarEvents = async (
    params: CalendarEventsQueryParams = {},
): Promise<GetCalendarEventsResponse> => {
    const response = await api.get('/calendar-events', {
        headers: {
            Accept: 'application/x-protobuf',
        },
        params,
        responseType: 'arraybuffer',
    })
    return GetCalendarEventsResponse.decode(new Uint8Array(response.data))
}
